import { Tabs } from "@ark-ui/solid";
import type { Component, VoidComponent } from "solid-js";
import { For } from "solid-js";

type ContentSwitcherItem = {
  label: string;
  key: string;
  Slot: Component;
};

type ContentSwitcherProps = {
  items: ContentSwitcherItem[];
  tabKey: string;
  onTabChange: (value: string) => void;
};

const ContentSwitcher: VoidComponent<ContentSwitcherProps> = (props) => (
  <Tabs.Root
    value={props.tabKey}
    onValueChange={({ value }) => {
      props.onTabChange(value);
    }}
    class="relative flex size-full flex-col pt-3"
    orientation="horizontal"
  >
    <Tabs.List class="mx-3 flex h-8 shrink-0 items-center justify-center rounded-sm bg-surface-extra-subtle p-0.5">
      <For each={props.items}>
        {(item) => (
          <Tabs.Trigger
            class="z-10 size-full overflow-hidden rounded-sm text-base-medium text-secondary hover:text-primary focus-visible:outline-default selected:text-primary"
            value={item.key}
          >
            {item.label}
          </Tabs.Trigger>
        )}
      </For>
      <Tabs.Indicator
        class="rounded-sm bg-surface-default ease-out!"
        style={{ width: "var(--width)", height: "var(--height)" }}
      />
    </Tabs.List>
    <For each={props.items}>
      {(item) => (
        <Tabs.Content class="w-full flex-1 overflow-y-auto pt-4" value={item.key}>
          <item.Slot />
        </Tabs.Content>
      )}
    </For>
  </Tabs.Root>
);

export default ContentSwitcher;
